export const STANDARD_COLORS = ['#3498DB', '#76D7C4', '#F4D03F', '#DC7633', '#A569BD', '#EC7063'];
